// eslint-disable-next-line no-unused-vars
import React from 'react';

const nonProdEnvs = ['dev-qa', 'qa', 'int', 'dev'];

// constants for external use so the values are consistently and constantly constant
export const careersFormLink = 'financial-representative-careers-form';
export const financialAdvisorCareersLink = 'financial-representative-careers';
export const internCareersLink = 'internships';
export const militaryCareersLink = 'post-military-careers';

const setLinkUrlPath = (thisUrl) => {
  if (nonProdEnvs.includes(process.env.NODE_CONFIG_ENV)) {
    // set non-prod links
    switch (thisUrl) {
      case 'financial-representative-careers':
        return 'https://northwesternmutual.staging.jibeapply.com/financial-advisors';
      case 'internships':
        return 'https://northwesternmutual.staging.jibeapply.com/interns';
      case 'post-military-careers':
        return 'https://northwesternmutual.staging.jibeapply.com/nm-military';
      case 'financial-representative-careers-form':
        return 'https://fieldcareersite-northwesternmutual2test.icims.com/jobs/2952/connect-with-a-recruiter-%28testing-do-not-post%29/login?_sp=75b3a9ee-78cd-4ee2-952f-f69fa0b0acd9.1730144087747&_ga=2.35006885.546822563.1730126916-483747041.1726770523&mobile=false&width=1150&height=500&bga=true&needsRedirect=false&jan1offset=-360&jun1offset=-300';
      default:
        return '/';
    }
  } else {
    // set prod links
    switch (thisUrl) {
      case 'financial-representative-careers':
        return 'https://opportunities.northwesternmutual.com/financial-advisors';
      case 'internships':
        return 'https://opportunities.northwesternmutual.com/students';
      case 'post-military-careers':
        return 'https://opportunities.northwesternmutual.com/military';
      case 'financial-representative-careers-form':
        return 'https://opportunities-northwesternmutual.icims.com/jobs/2952/connect-with-a-recruiter/login';
      default:
        return '/';
    }
  }
};

export const getAllQueryParams = () => {
  let queryParamsString = '';
  if (typeof window !== 'undefined') {
    queryParamsString = window.location.search;
  }
  return queryParamsString;
};

export default async (url) => {
  const linkUrl = setLinkUrlPath(url);
  return linkUrl;
};
